module.exports = __webpack_public_path__ + "media/images/application2/AppEvents__body__dl__item__socials__a--ig-dd99e2251227411ef212bf5c1d855609.svg";